import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import animationData from "../../../assets/Document.json";
import animationData2 from "../../../assets/first doc.json";
import Encryption from "../../../assets/Encryption.png";
import Data from "../../../assets/Data Security.png";
import Contract from "../../../assets/Your Contract.png";
import Secured from "../../../assets/Secured.png";
import { CircularProgress } from "@mui/material";

interface Step {
  title: string;
  animation: typeof animationData | typeof animationData2 | string;
}

function NewLoader() {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const steps: Step[] = [
    { title: "Reviewing key clauses and risks..", animation: animationData2 },
    // { title: "Amendment to Master Services Agreement", animation: animationData },
    { title: "Confidentiality Breach", animation: animationData },
    { title: "Indemnification", animation: animationData },
    { title: "Data Security & Remedies", animation: animationData },
    { title: "Termination Clause", animation: animationData },
    { title: "Limitations of Liability", animation: animationData },
    { title: "Warranties & Remedies", animation: animationData },
    { title: "Insurance", animation: animationData },
    { title: "Payment Terms", animation: animationData },
    { title: "Notices", animation: animationData },
    { title: "Securing your Data ...", animation: Encryption },
    { title: "Encryption in Progress ...", animation: Data },
    { title: "Your Contract is secured ... ", animation: Secured },
    { title: "Analysis results are almost ready ... ", animation: Contract },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentStep((prevStep) => (prevStep + 1) % steps.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [steps.length]);

  const currentStepData: Step = steps[currentStep];

  const isImage = (animation: Step["animation"]): animation is string => {
    return typeof animation === "string";
  };

  return (
    <div
      style={{
        display: "grid",
        placeContent: "center",
        placeItems: "center",
        height: "100%",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* <p style={{ fontSize: "10px", marginBottom: "4px" }}>{`${currentStep + 1}/${steps.length}`}</p> */}
      <CircularProgress variant="determinate" value={currentStep * 10} />
      <p
        style={{
          fontSize: "16px",
          color: "#333",
          fontWeight: "bold",
          marginTop: "10px",
          transition: "opacity 0.5s ease",
        }}
      >
        {currentStepData.title}
      </p>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {isImage(currentStepData.animation) ? (
          <img
            src={currentStepData.animation}
            alt={currentStepData.title}
            style={{ width: "105px", height: "105px", objectFit: "contain", marginBottom: "5rem" }}
          />
        ) : (
          <Lottie
            animationData={currentStepData.animation}
            loop
            autoplay
            style={{ width: "95px", height: "135px", backgroundColor: "transparent", marginBottom: "5rem" }}
          />
        )}
        <p style={{ fontSize: "14px", color: "#4A88EE", fontWeight: "bold", paddingTop: "5px" }}>
          The whole process usually
          <br />
          takes up to 3-4 minutes...
        </p>
      </div>
    </div>
  );
}

export default NewLoader;
